import { render, staticRenderFns } from "./confirm-pay-my.vue?vue&type=template&id=769631a0&scoped=true&"
import script from "./confirm-pay-my.vue?vue&type=script&lang=js&"
export * from "./confirm-pay-my.vue?vue&type=script&lang=js&"
import style0 from "./confirm-pay-my.vue?vue&type=style&index=0&id=769631a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769631a0",
  null
  
)

export default component.exports